module.exports = __webpack_public_path__ + "img/20.a5762b0b.jpg";